import { getItemFromStorage } from "../../helper/storage";
import { authorizedFetch, baseUrl, buildHeaders, getResponseOrThrow, urlFilters } from "./common";

export const apiListExpectedScores = (filters) => {
  const token = getItemFromStorage("TOKEN");
  const company_id = getItemFromStorage("COMPANY_ID");
  return authorizedFetch(
    urlFilters(`${baseUrl}/company/${company_id}/topics/expected-scores`, filters),
    {
      method: "GET",
      headers: buildHeaders(token)
    }
  )
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};

export const apiCreateOrUpdateExpectedScores = (expectedScores) => {
  const token = getItemFromStorage("TOKEN");
  const company_id = getItemFromStorage("COMPANY_ID");
  return authorizedFetch(
    `${baseUrl}/company/${company_id}/topics/expected-scores`,
    {
      method: "POST",
      headers: buildHeaders(token),
      body: JSON.stringify(expectedScores)
    }
  )
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};

export const apiListPendingEvaluations = (employee_id, filters) => {
  const token = getItemFromStorage("TOKEN");
  const company_id = getItemFromStorage("COMPANY_ID");
  return authorizedFetch(
    urlFilters(`${baseUrl}/company/${company_id}/employee/${employee_id}/evaluations/pending`, filters),
    {
      method: "GET",
      headers: buildHeaders(token)
    }
  )
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};
